// 3rd Party
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

// Components
import { Modal } from 'opencare-crown';
import {
  Div,
  H1,
  P,
  MarketingButton,
} from 'common/styles/oc-styled-components';

import { useRedirectionService } from 'services/RedirectionService';

import ToothySad from '../../../common/components/svgs/ToothySad';

// Other
import { RECOMMENDATION_PATH } from '../../../../containers/App/Routes';

// Component
const NoAvailableProvidersModal = ({ showNoAvailableProvidersModal }) => {
  const redirectionService = useRedirectionService();

  const goToFunnel = useCallback(() => {
    redirectionService.redirect({
      url: RECOMMENDATION_PATH,
      reason: 'no-available-providers-start-funnel',
    });
  });

  return (
    <Modal
      footer={null}
      closable={false}
      visible={showNoAvailableProvidersModal}
    >
      <Div textAlign="center">
        <ToothySad height="100px" width="100px" />
        <H1 margin="10px 0 5px">
          Sorry! This clinic has temporarily suspended accepting new Opencare
          patients.
        </H1>
        <P margin="0 0 15px 0">
          Take our quiz to find other great dentists in your area.
        </P>
        <MarketingButton
          type="primary"
          size="large"
          shape="round"
          onClick={() => goToFunnel()}
        >
          Find your new dentist
        </MarketingButton>
      </Div>
    </Modal>
  );
};

NoAvailableProvidersModal.propTypes = {
  showNoAvailableProvidersModal: PropTypes.bool,
};

export default NoAvailableProvidersModal;
